import React, { Component } from 'react';
import axios from 'axios';
import Select from 'react-select'; // 👈 react-select eklendi
import './App.css';

class BonusTalepForm extends Component {
  state = {
    bonusKategorisi: '',
    bonuslar: [],
    secilenBonus: '',
    talepGonderiliyor: false,
    loading: false,
    talepStatus: '',
    kullaniciAdi: '',
    bonusGeçmişi: [],
    error: false,
    selectedBonus: null,
  };

  getBonusName = (bonusId) => {
    const bonusNames = {
      freespin: '250 Pragmatic Freespin',
      freebet: '250 Spor Freebet',
      1100: "%30 Çevrimsiz Casino/Canlı Casino Kayıp Bonusu",
      1101: '%25 Çevrimsiz Spor Kayıp Bonusu',
      1102: '%10 Ekstra Kayıp Bonusu (Spor)',
      1103: '%10 Ekstra Kayıp Bonusu (Casino)',
      1031: 'İlk Yatırıma %50 Çevrimsiz Kayıp Bonusu',
      1005: '%100 Casino Hoşgeldin Bonusu',
      1006: '%100 Canlı Casino Hoşgeldin Bonusu',
      1012: '1000 TL Yatır 2000 TL Başla!',
      1007: '%100 Spor Hoşgeldin Bonusu',
      1028: '%300 İlk Yatırım Casino Bonusu',
      1029: '%300 İlk Yatırım Canlı Casino Bonusu',
      1030: '%300 İlk Yatırım Spor Bonusu',
      1004: '%50 Slot Bonusu',
      1002: '%20 Casino & Slot Bonusu',
      1001: '%20 Spor Yatırım Bonusu',
      2001: 'Gün Sonu Freespin',
      1110: '%5 Haftalık Kayıp Bonusu - Spor',
      1111: '%5 Haftalık Kayıp Bonusu - Casino',
    };
    return bonusNames[bonusId] || 'Bilinmeyen Bonus Türü';
  };

  clearNotification = () => {
    setTimeout(() => {
      this.setState({ talepStatus: '' });
    }, 5000);
  };

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const usernameFromUrl = urlParams.get('username');
    this.setState({ kullaniciAdi: usernameFromUrl || '' }, this.fetchBonusGeçmişi);

    this.interval = setInterval(this.fetchBonusGeçmişi, 10000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  fetchBonusGeçmişi = () => {
    const { kullaniciAdi } = this.state;
    if (kullaniciAdi) {
      axios
        .get(`https://hazdevelope.com:2000/request/userThreeRequest?username=${kullaniciAdi}`)
        .then((response) => {
          this.setState({ bonusGeçmişi: response.data });
        })
        .catch((error) => {
          console.error('Bonus geçmişi yüklenirken hata:', error);
        });
    }
  };

  handleBonusKategorisiChange = (selectedOption) => {
    const selectedCategory = selectedOption.value;
    const bonuslar = this.getBonuslarByCategory(selectedCategory);
    this.setState({
      bonusKategorisi: selectedCategory,
      bonuslar,
      secilenBonus: '',
      talepStatus: '',
    });
  };

  handleSecilenBonusChange = (selectedOption) => {
    this.setState({ secilenBonus: selectedOption.value });
  };

  handleTalepGonder = () => {
    const { kullaniciAdi, secilenBonus } = this.state;

    if (!kullaniciAdi || !secilenBonus) {
      this.setState({ talepStatus: 'Lütfen tüm alanları doldurun' }, this.clearNotification);
      return;
    }

    const bonusType = this.getBonusTypeByBonusName(secilenBonus);
    const requestURL = `https://hazdevelope.com:2000/request/add?username=${kullaniciAdi}&bonustype=${bonusType}`;

    this.setState({ talepGonderiliyor: true, loading: true });

    axios
      .post(requestURL)
      .then((response) => {
        this.setState({ loading: false });
        const message = response.data.message;
        this.setState({ talepStatus: message }, this.clearNotification);
        this.fetchBonusGeçmişi();
      })
      .catch(() => {
        this.setState({ loading: false, talepStatus: 'Talep gönderme başarısız oldu' }, this.clearNotification);
      })
      .finally(() => {
        this.setState({ talepGonderiliyor: false });
      });
  };

  getBonuslarByCategory(selectedCategory) {
    if (selectedCategory === 'yatirimbonusu') {
      return [
        {
          label: "- Casino Bonusları -",
          options: [
            { value: '%100 Casino Hoşgeldin Bonusu', label: '%100 Casino Hoşgeldin Bonusu' },
            { value: '%300 İlk Yatırım Casino Bonusu', label: '%300 İlk Yatırım Casino Bonusu' },
            { value: '%50 Slot Bonusu', label: '%50 Slot Bonusu' },
            { value: '%20 Casino & Slot Bonusu', label: '%20 Casino & Slot Bonusu' },
            { value: '1000 TL Yatır 2000 TL Başla!', label: '1000 TL Yatır 2000 TL Başla!' },
          ]
        },
        {
          label: "- Canlı Casino Bonusları -",
          options: [
            { value: '%100 Canlı Casino Hoşgeldin Bonusu', label: '%100 Canlı Casino Hoşgeldin Bonusu' },
            { value: '%300 İlk Yatırım Canlı Casino Bonusu', label: '%300 İlk Yatırım Canlı Casino Bonusu' },
            { value: '1000 TL Yatır 2000 TL Başla!', label: '1000 TL Yatır 2000 TL Başla!' },
          ]
        },
        {
          label: "- Spor Bonusları -",
          options: [
            { value: '%100 Spor Hoşgeldin Bonusu', label: '%100 Spor Hoşgeldin Bonusu' },
            { value: '%300 İlk Yatırım Spor Bonusu', label: '%300 İlk Yatırım Spor Bonusu' },
            { value: '%20 Spor Yatırım Bonusu', label: '%20 Spor Yatırım Bonusu' },
          ]
        }
      ]
    }

    const flatList = {
      kayipbonusu: [
        { value: '%30 Çevrimsiz Casino/Canlı Casino Kayıp Bonusu', label: '%30 Çevrimsiz Casino/Canlı Casino Kayıp Bonusu' },
        { value: '%25 Çevrimsiz Spor Kayıp Bonusu', label: '%25 Çevrimsiz Spor Kayıp Bonusu' },
        { value: 'İlk Yatırıma %50 Çevrimsiz Kayıp Bonusu', label: 'İlk Yatırıma %50 Çevrimsiz Kayıp Bonusu' },
        { value: '%5 Haftalık Kayıp Bonusu - Casino', label: '%5 Haftalık Kayıp Bonusu - Casino' },
        { value: '%5 Haftalık Kayıp Bonusu - Spor', label: '%5 Haftalık Kayıp Bonusu - Spor' },
      ],
      ozelbonuslar: [{ value: 'Gün Sonu Freespin', label: 'Gün Sonu Freespin' }],

      denemebonuslar: [
        { value: '250 Pragmatic Freespin', label: '250 Pragmatic Freespin' },
        { value: '250 Spor Freebet', label: '250 Spor Freebet' }
      ],
    };

    return flatList[selectedCategory] || [];
  }

  getNotificationStyle = (status) => {
    const styles = {
      'Lütfen tüm alanları doldurun': { backgroundColor: '#FF5733', color: '#fff' },
      'Bekleyen talebiniz mevcuttur.': { backgroundColor: '#4682b4', color: '#fff' },
      'Talep oluşturulurken bir hata oluştu.': { backgroundColor: '#FF5733', color: '#fff' },
      'Talebiniz başarılı bir şekilde oluşturulmuştur.': { backgroundColor: '#3cb371', color: '#fff' },
    };
    return styles[status] || {};
  };

  getNotificationMessage = (status) => {
    const messages = {
      'Lütfen tüm alanları doldurun': 'Lütfen tüm alanları doldurunuz.',
      'Bekleyen talebiniz mevcuttur.': 'Bekleyen talebiniz mevcuttur.',
      'Talep oluşturulurken bir hata oluştu.': 'Talep oluşturulurken bir hata oluştu.',
      'Talebiniz başarılı bir şekilde oluşturulmuştur.': 'Talep başarılı bir şekilde oluşturulmuştur.',
    };
    return messages[status] || '';
  };

  getBonusTypeByBonusName(bonusName) {
    const bonusTypes = {
      "250 Pragmatic Freespin": 'freespin',
      "250 Spor Freebet": 'freebet',
      "%30 Çevrimsiz Casino/Canlı Casino Kayıp Bonusu": '1100',
      '%25 Çevrimsiz Spor Kayıp Bonusu': '1101',
      '%10 Ekstra Kayıp Bonusu (Spor)': '1102',
      '%10 Ekstra Kayıp Bonusu (Casino)': '1103',
      'İlk Yatırıma %50 Çevrimsiz Kayıp Bonusu': '1031', //%100 nakit iade gibi
      '%100 Casino Hoşgeldin Bonusu': '1005',
      '%100 Canlı Casino Hoşgeldin Bonusu': '1006',
      '1000 TL Yatır 2000 TL Başla!': '1012',
      '%100 Spor Hoşgeldin Bonusu': '1007',
      '%300 İlk Yatırım Casino Bonusu': '1028',
      '%300 İlk Yatırım Canlı Casino Bonusu': '1029',
      '%300 İlk Yatırım Spor Bonusu': '1030',
      '%50 Slot Bonusu': '1004',
      '%20 Casino & Slot Bonusu': '1002',
      '%20 Spor Yatırım Bonusu': '1001',
      'Gün Sonu Freespin': '2001',
      '%5 Haftalık Kayıp Bonusu - Spor': '1110',
      '%5 Haftalık Kayıp Bonusu - Casino': '1111',
    };
    return bonusTypes[bonusName] || '';
  }

  render() {
    const { talepStatus, bonusGeçmişi, selectedBonus } = this.state;

    const kategoriOptions = [
      { value: 'yatirimbonusu', label: 'Yatırım Bonusları' },
      { value: 'kayipbonusu', label: 'Kayıp Bonusu' },
      { value: 'ozelbonuslar', label: 'Özel Bonuslar' },
      { value: 'denemebonuslar', label: 'Deneme Bonusları' },
    ];

    const customSelectStyles = {
      control: (base, state) => ({
        ...base,
        backgroundColor: '#1e1e20',
        borderColor: state.isFocused ? '#f8ac34' : '#777070', // 👈 Focus turuncu
        boxShadow: state.isFocused ? '0 0 0 1px #f8ac34' : 'none', // 👈 React-select default mavi shadow override edildi
        color: '#f1f1f1ff',
        borderRadius: 6,
        padding: '2px 4px',
        minHeight: 42,
      }),
      singleValue: (base) => ({
        ...base,
        color: '#d3ceceff',
      }),
      menu: (base) => ({
        ...base,
        backgroundColor: '#2a2a2d',
        border: '1px solid #444',
        borderRadius: 6,
        marginTop: 6,
        zIndex: 9999, // 👈 bonus geçmişinin üstüne çıkar
        boxShadow: '0 4px 8px rgba(0,0,0,0.4)', // 👈 menüye gölge
      }),
      option: (base, state) => ({
        ...base,
        backgroundColor: state.isFocused ? '#3a3a3d' : '#2a2a2d',
        color: state.isFocused ? '#d3ceceff' : '#d3ceceff',
        cursor: 'pointer',
        padding: '8px 12px',
      }),
      placeholder: (base) => ({
        ...base,
        color: '#aaa',
      }),
    };

    return (
      <div className="container">
        <div className="form">
          <img src="/haz_logo.svg" alt="Hazbet Logo" style={{ maxWidth: '150px', height: 'auto' }} />
          <h2>Bonus Talep Formu</h2>
          {this.state.loading ? (
            <h5 style={{ color: '#f27127' }}>Bonusunuz kontrol ediliyor...</h5>
          ) : (
            <h5 style={{ color: '#afa8a8' }}>
              Hoş geldiniz {this.state.kullaniciAdi}, aşağıdan bonusunuzu seçiniz:
            </h5>
          )}

          <div className="form-group">
            <label className="label">Bonus Kategorisi:</label>
            <Select
              options={kategoriOptions}
              onChange={this.handleBonusKategorisiChange}
              placeholder="Seçiniz"
              styles={customSelectStyles}
            />
          </div>

          {this.state.bonuslar.length > 0 && (
            <div className="form-group">
              <label className="label">Bonus Seç:</label>
              <Select
                options={this.state.bonuslar}
                onChange={this.handleSecilenBonusChange}
                placeholder="Seçiniz"
                styles={customSelectStyles}
              />
            </div>
          )}

          {talepStatus && (
            <div className="notification" style={this.getNotificationStyle(talepStatus)}>
              {this.getNotificationMessage(talepStatus)}
            </div>
          )}

          <div className="form-group">
            <button className="button" onClick={this.handleTalepGonder}>
              <b>Talebi Gönder</b>
            </button>
          </div>

          <div className="bonus-talepleri-form">
            <hr className="separator" />
            <div className="bonus-gecmisi">
              <h3>Bonus Geçmişi</h3>
              {bonusGeçmişi.length === 0 ? (
                <p>Bonus geçmişiniz bulunmamaktadır.</p>
              ) : (
                <table>
                  <thead>
                    <tr>
                      <th>Bonus Türü</th>
                      <th>Durum</th>
                      <th>Talep Tarihi</th>
                      <th>Red Nedeni</th>
                    </tr>
                  </thead>
                  <tbody>
                    {bonusGeçmişi.map((bonus, index) => (
                      <tr key={index}>
                        <td>{this.getBonusName(bonus.bonusType)}</td>
                        <td>
                          <span className={`status-badge ${bonus.status}`}>
                            {bonus.status === 'rejected'
                              ? 'Rededildi'
                              : bonus.status === 'approved'
                                ? 'Onaylandı'
                                : 'Beklemede'}
                          </span>
                        </td>
                        <td>{new Date(bonus.createdAt).toLocaleString()}</td>
                        <td>
                          {bonus.status === 'rejected' && (
                            <button
                              className="show-reason-btn"
                              onClick={() => this.setState({ selectedBonus: bonus })}
                            >
                              Göster
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}

              {selectedBonus && (
                <div className="modal-overlay">
                  <div className="modal-content">
                    <h4>Red Nedeni</h4>
                    <p>{selectedBonus.rejectReason || 'N/A'}</p>
                    <button onClick={() => this.setState({ selectedBonus: null })}>Kapat</button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BonusTalepForm;
